import tmhRequest from '@/config/tmhRequest'

export default {


    searchApplyTransferMyCardCount: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applytransfermycard/searchapplytransfermycardcount',
            method: 'post',
            data: data,
        })
    },

    searchApplyTransferMyCardByPage: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applytransfermycard/searchapplytransfermycardbypage',
            method: 'post',
            data: data,
        })
    },

    createApplyTransferMyCard: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applytransfermycard/createapplytransfermycard',
            method: 'post',
            data: data,
        })
    },
    closeApplyTransferMyCard: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applytransfermycard/closeapplytransfermycard',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/apply/applytransfermycard.js